/* eslint-disable import/prefer-default-export */
/* eslint-disable import-helpers/order-imports */

import { useEffect, useState } from 'react';

import useSaflSocket from './useSaflSocket';

const usePresencaTotal = (sessaoId) => {
  const socket = useSaflSocket();
  const [presencaTotal, setPresencaTotal] = useState(null);

  useEffect(() => {
    if (!socket || !sessaoId) {
      setPresencaTotal(null);
      return undefined;
    }

    const normalizedSessaoId = Number(sessaoId);
    setPresencaTotal(null);

    const handleCount = (payload = {}) => {
      if (Number(payload.sessaoId) !== normalizedSessaoId) {
        return;
      }

      const value = Number(payload.total);
      setPresencaTotal(Number.isFinite(value) ? value : 0);
    };

    const requestCount = () => {
      socket.emit('presenca:get', { sessaoId: normalizedSessaoId });
    };

    const handleConnect = () => {
      requestCount();
    };

    socket.on('presenca:count', handleCount);
    socket.on('connect', handleConnect);

    if (socket.connected) {
      requestCount();
    }

    return () => {
      socket.off('presenca:count', handleCount);
      socket.off('connect', handleConnect);
    };
  }, [socket, sessaoId]);

  return presencaTotal;
};

export default usePresencaTotal;
